import React, { useEffect, useState } from 'react';
import {
  DatePicker,
  CortisolMetricsGraphCard,
  CortisolMetricsDescriptor,
} from './index';
import { HormoneSnapshot } from '../../../types';

export const CortisolMetrics = ({
  snapshots,
}: {
  snapshots: HormoneSnapshot[];
}): JSX.Element => {
  const [selectedSnapshot, setSelectedSnapshot] =
    useState<HormoneSnapshot | null>(null);

  useEffect(() => {
    if (snapshots.length > 0 && !selectedSnapshot) {
      setSelectedSnapshot(snapshots[0]);
    }
  }, [snapshots]);

  const handleDateChange = (newSnapshot: HormoneSnapshot) => {
    setSelectedSnapshot(newSnapshot);
  };

  const selectedSnapshotIndex = snapshots.findIndex(
    (snapshot) => snapshot === selectedSnapshot
  );

  const previousSnapshot =
    selectedSnapshotIndex > 0 ? snapshots[selectedSnapshotIndex - 1] : null;

  return (
    <>
      {snapshots.length > 0 && (
        <>
          <DatePicker snapshots={snapshots} onDateChange={handleDateChange} />
          {selectedSnapshot && (
            <>
              <CortisolMetricsGraphCard snapshot={selectedSnapshot} />
              <CortisolMetricsDescriptor
                currentSnapshot={selectedSnapshot}
                prevSnapshot={previousSnapshot}
              />
            </>
          )}
        </>
      )}
    </>
  );
};
